export default {
  titulos: {
    listagem: 'Certificados',
    visualizar: 'Visualizar Certificado - Cód: {codigo}',
    visualizar_certificado: 'Visualizar Certificado',
    visualizar_certificado_terceiro: 'Visualizar certificado de terceiro',
    visualizar_certificado_padroes: 'Visualizar Certificados dos Padrões'
  },
  tabela: {
    codigo: 'Código',
    codigo_instrumento: 'Instrumento',
    tipo_instrumento: 'Tipo de Instrumento',
    cliente: 'Cliente',
    tipo_calibracao: 'Tipo de Calibração',
    situacao: 'Situação',
    situacao_certificado: 'Situação Certificado',
    situacao_avaliacao: 'Situação Avaliação',
    ordem_servico: 'Ficha de Acompanhamento',
    data_calibracao: 'Calibrado Em',
    usuario_signatario: 'Usuário Signatário',
    liberarClientes: 'Liberado para Cliente',
  },
  depuracao: {
    depuracao_avaliacao_certificado: 'Depurar Avaliação do Certificado',
    titulo: 'Depuração',
    depuracao_nao_gerada: 'Nenhuma depuração foi gerada',
    click_botao_gerar_depuracao:
      'Clique no botão abaixo para gerar a depuração.',
    cancelar: '',
    gerar_depuracao: 'Gerar depuração',
    depurar_avaliacao: 'Depurar avaliação',
    confirmar_avaliacao: 'Confirmar Avaliação',
  },
  idioma_certificado: 'Idioma do Certificado: ',
  confirmar_assinar:
    'Você tem certeza que deseja assinar o certificado selecionado?',
  confirmar_cancelar:
    'Você tem certeza que deseja cancelar a calibração selecionada',
  assinado_sucesso: 'Certificado assinado com sucesso',
  cancelado_sucesso: 'Calibração cancelada com sucesso',
  cancelar_substituir:
    'Você tem certeza que deseja cancelar e substituir o certificado selecionado?',
  tooltip:
    'Verifique a situação do certificado, perfil não permite executar essa ação.',
  tooltip_checklist: 'Há checklist não conforme',
  checklist: {
    checklist: 'Checklist',
    opcoes: {
      conforme: 'Conforme',
      naoConforme: 'Não conforme',
    },
  },
  requisitos: {
    requisitos_participante_calibracao:
      'Requisitos do Participante - Calibração',
    sem_requisitos: 'Não há requisitos para este tipo de calibração',
  },
  botoes: {
    certificado: 'Certificado',
    assinar_certificado: 'Assinar Certificado',
    cancelar_certificado: 'Cancelar Certificado',
    cancelar_substituir: 'Cancelar e Substituir Certificado',
    definir_derivas: 'Definir Derivas',
    avaliar: 'Avaliar Certificado',
    visualizar_calibracao: 'Visualizar Calibração',
    visualizar_padroes: 'Visualizar Padrões',
    visualizar_certificado: 'Visualizar Certificado',
  },
  filtro: {
    codigo: 'Código',
    codigo_instrumento: 'Cód. do Instrumento',
    codigo_ordem_servico: 'Cód. da FA',
    nome_tipo_instrumento: 'Tipo de Instrumento',
    instrumento: 'Instrumento',
    nome_cliente: 'Cliente',
    tipo_calibracao: 'Tipo de Calibração',
    situacao: 'Situação Certificado',
    calibrado_em: 'Calibrado Em',
    situacao_avaliacao: 'Situação Avaliação',
  },
  erros: {
    id_invalido: 'O id da prioridade é inválido',
  },
  definir_derivas: {
    alerta_faixas:
      'Existem faixas que estão sem a definição de derivas. É necessário salvar todas as faixas.',
    alerta_conformidades:
      "Para prosseguir é necessário que não haja itens 'Não Conformes.'",
    titulo: 'Definir Derivas',
    filtro: {
      grafico: 'Gráfico',
      faixa_instrumento: 'Faixa do Instrumento',
      curva_correcao: 'Curva de Correção',
      grau_polinomio: 'Grau do Polinômio',
      percentual_leituras: 'Percentual das Leituras',
    },
    salvar_sucesso: 'Derivas salvas com sucesso!',
    conformidades_sucesso: 'Conformidades salvas com sucesso!',
    indicadores_sucesso: 'Indicador salvo com sucesso!',
    finalizar_sucesso: 'Definição das derivas finalizada com sucesso!',
    confirmar_finalizar: 'Deseja finalizar a definição de derivas?',
    curva: 'Curva de correção',
    conformidade: 'Conformidade',
    indicador: 'Indicador',
    indicadores: {
      certificados: 'Certificados',
      instrumento: 'Instrumento',
      faixa: 'Faixa',
      indicadorDeriva: 'Indicador da Deriva',
      valorDeriva: 'Valor da Deriva',
      desvioPadrao: 'Desvio Padrão do Resíduo da Curva',
      maxResiduo: 'Máximo Resíduo da Curva',
      mediaResiduo: 'Média do Resíduo da Curva',
      valor: 'Valor da Deriva',
    },
    opcoes: {
      graficos: {
        erro: 'Erro',
        erro_incerteza: 'Erro + Incerteza',
        incerteza: 'Incerteza',
      },
      curva_correcao: {
        polinomio: 'Polinômio',
        percentual: 'Percentual',
        interpolacao: 'Interpolação',
        sem_correcao: 'Sem correção',
      },
      conformes: {
        conforme: 'Conforme',
        nao_conforme: 'Não conforme',
        nao_se_aplica: 'Não se aplica',
      },
    },
    formula_curva: 'Fórmula da Curva',
    tabela_certificado: {
      ultimo_certificado: 'Último Certificado {nome}',
      certificado_atual: 'Certificado Atual {nome}',
      erro: 'Erro',
      erro_corrigido: 'Erro Corrigido',
      deriva: 'Deriva',
      valor_referencia: 'Valor de Referência',
    },
    tabela_pontos: {
      ponto: 'Ponto',
      nome: 'Nome',
    },
    grafico: {
      erro: 'Erro',
      tendencia: 'Erro corrigido',
      incerteza: 'Incerteza',
    },
    modal_conformidades: {
      titulo: 'Atenção',
      descricao:
        'Antes de salvar é necessário informar a Conformidade dos itens.',
      itens: 'Itens',
      conforme: 'Conforme',
      selecione: 'Selecione',
    },
  },
  avaliacao: {
    titulo: {
      texto: 'Avaliar Resultados',
      instrumento: 'Instrumento: {instrumento}',
      certificado: 'Certificado: {certificado}',
    },
    depuracao_modal: {},
    sucesso: 'Avaliação realizada com sucesso',
    revalidar_sucesso: 'Critérios revalidados com sucesso',
    situacao_avaliacao: 'Situação Avaliação do Certificado',
    confirmar_avaliacao: 'Confirmar Avaliação',
    confirmar_avaliacao_informativo:
      'Informe uma justificativa para confirmar a Avaliação',
    confirmar_avaliacao_justificativa: 'Justificativa',
    ocorrencia: 'Ocorrências',
    inativar_instrumento: 'Inativar Instrumento',
    revalidar_criterio: 'Revalidar Critérios',
    tooltip_salvar:
      'Tabela(as) sem critérios de aceitação: {tabelasSemCriterio}',
    tabela: {
      ponto_calibracao: 'Ponto de Calibração',
      nome: 'Nome',
      erro: 'Erro',
      incerteza: 'Incerteza',
      erro_incerteza: 'Erro + Incerteza',
      criterio: 'Critério',
      nome_criterio: 'Nome do Critério',
      formula_validacao: 'Fórmula de Validação',
      situacao_avaliacao: 'Situação Avaliação',
      formula: 'Fórmula',
    },
  },
  grafico_tendencia: {
    titulo: 'Gráfico de Tendências',
    instrumento: 'Instrumento',
    tipo_instrumento: 'Tipo de Instrumento',
    tipo_grafico: 'Tipo de Gráfico',
    faixa_instrumento: 'Faixa do Instrumento',
    certificados: 'Certificado(s)',
    tabela_calibracao: 'Tabela de Calibração',
  },
};
